import React, { useState } from 'react'
import './affidavit.css'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faFileLines, faQuestionCircle, faRefresh, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

function Affidavit() {

    const dummyAffidavitDocs = [
        {
            title: 'AFFIDAVIT OF DECLARATION OF MARRIAGE',
            docId: 34,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'GENERAL AFFIDAVIT 1',
            docId: 51,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'GENERAL AFFIDAVIT',
            docId: 60,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'DAMAGED PASSPORT',
            docId: 79,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'CHANGE OF OWNERSHIP(VEHICLE)',
            docId: 158,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'GOOD CONDUCT (WORK)',
            docId: 22,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'GOOD CONDUCT (SCHOOL)',
            docId: 56,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'SINGLE MOTHER',
            docId: 105,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'PROOF OF DEATH',
            docId: 78,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'FORM A',
            docId: 11,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'CHANGE OF SIGNATURE',
            docId: 30,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'BIOMETRIC UPDATE',
            docId: 29,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'AFFIDAVIT OF SPINSTERHOOD',
            docId: 67,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'CORRECTION OF NAME ON BIRTH CERTIFICATE',
            docId: 209,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'AFFIDAVIT OF BIDDING',
            docId: 266,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'AFFIDAVIT OF FACTS',
            docId: 190,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: ' CONTRACTOR REGISTRATION',
            docId: 99,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'AFFIDAVIT OF MEANS',
            docId: 71,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'SALE OF LAND',
            docId: 23,
            datecreated: 'Fri Jan 19 2024',
        },
        {
            title: 'CHANGE OF (VEHICLE) ENGINE',
            docId: 17,
            datecreated: 'Fri Jan 19 2024',
        },
    ]

    const [deleteBox, setDeleteBox] = useState(false)

  return (
    <div className='affidavit-table'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Hi, Joseph Sanni</h2>
                    </div>
                    <p>Your role: Document Manager</p>
                </div>
                <p className="nav-status">Home/Affidavit-templates</p>
            </div>
            <div className="search-table">
                <div className="form-inp">
                   
                    <input type="text" placeholder='Search by Title' id='search-title'/>
                </div>
                <button className='red'>Search <FontAwesomeIcon icon={faSearch} /></button>
                <div className="reset-fields">
                    <p>Reset Fields</p>
                    <FontAwesomeIcon icon={faRefresh} />
                </div>
            </div>
            <div className="aff-table">
                <div className="all-div">
                    <FontAwesomeIcon icon={faFileLines} />
                    <h3>All Templates</h3>
                </div>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Document ID</th>
                                <th>Date Created</th>
                                <th>Type</th>
                                <th>Action</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dummyAffidavitDocs.map((doc, i) => { return (
                                    <tr key={i}>
                                        <td>{doc.title}</td>
                                        <td>{doc.docId}</td>
                                        <td>{doc.datecreated}</td>
                                        <td>AFFIDAVIT</td>
                                        <td className='view-affbtn'>
                                            <Link to='/edm/create-temp/view-temp'><button>View <FontAwesomeIcon icon={faAngleRight} /></button></Link>
                                        </td>
                                        <td className='del-aff' onClick={() => setDeleteBox(true)}>Delete <FontAwesomeIcon icon={faTrash} /></td>
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={ deleteBox ? "delete-box open" : "delete-box"}>
                <div className="delete-wrap">
                    <FontAwesomeIcon icon={faQuestionCircle} />
                    <h2>Do you want to delete this Affidavit Template?</h2>
                    <div className="del-btns">
                        <button className='red' onClick={() => setDeleteBox(false)}>Yes</button>
                        <button className='black' onClick={() => setDeleteBox(false)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Affidavit